<template>
  <div class="bu-card-template-skeleton">
    <!-- Avatar -->
    <div class="profile-section">
      <b-skeleton-img width="80px" height="80px" />
      <b-skeleton width="60%" class="m-0 full-name" />
      <b-skeleton width="40%" class="m-0 job-title" />
    </div>

    <!-- Logo Services -->
    <div class="logo-services">
      <b-skeleton-img v-for="n in 3" :key="n" width="40px" height="40px" />
    </div>

    <!-- Save Contact Button -->
    <b-skeleton width="100%" height="38px" class="save-contact-btn" />

    <!-- Contact Info -->
    <div class="contact-info">
      <b-skeleton v-for="n in 5" :key="n" height="50px" class="info-item" />
    </div>
  </div>
</template>
<script>
export default {
  name: "Skeleton",
};
</script>
<style lang="scss">
@import "@/assets/scss/helpers/helpers";

.bu-card-template-skeleton {
  /* ===== base tokens ===== */
  --radius: 0.625rem;
  --radius-xl: calc(var(--radius) + 4px);
  --radius-2xl: 1rem;
  --shadow-lg: 0 0 0px #0000, 0 0 0px #0000, 0 0 0px #0000, 0 0 0px #0000,
    0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);

  --container-sm: 24rem;

  /* ===== color palette ===== */
  --color-white: #fff;

  --color-gray-100: oklch(96.7% 0.003 264.542);
  --color-gray-200: oklch(92.8% 0.006 264.531);
  --color-gray-600: oklch(44.6% 0.03 256.802);
  --color-gray-700: oklch(37.3% 0.034 259.733);
  --color-gray-900: oklch(21% 0.034 264.665);

  /* ===== template custom variables ===== */
  /* Card Base */
  --bg-card: var(--color-white);
  --border-card: var(--color-gray-100);

  /* Contact Info */
  --border-info: var(--color-gray-200);

  background-color: var(--bg-card);
  box-shadow: var(--shadow-lg);
  padding: 1.5rem;
  border-radius: var(--radius-2xl);
  width: 100%;
  max-width: var(--container-sm);
  margin: #{px-to-rem(24)} auto;
  border: 1px solid var(--border-card);
  @include space-y(1.5rem);

  .profile-section {
    display: flex;
    flex-direction: column;
    align-items: center;
    .b-aspect.d-flex {
      margin-bottom: 1rem;
      border-radius: 100% !important;
      overflow: hidden;
    }
    .full-name,
    .job-title {
      margin-bottom: 0 !important;
    }
    .job-title {
      margin-top: 0.5rem !important;
    }
  }
  .logo-services {
    display: flex;
    justify-content: center;
    gap: 0.75rem;
    flex-wrap: wrap;
    .b-aspect.d-flex {
      border-radius: 100% !important;
      overflow: hidden;
    }
  }
  .save-contact-btn {
    border-radius: var(--radius-xl);
  }
  .contact-info {
    @include space-y(0.5rem);
    .info-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 1rem;
      border: 1px solid var(--border-info);
      border-radius: var(--radius);
    }
  }
}

.dark-layout {
  .bu-card-template-skeleton {
    /* Card Base */
    --bg-card: var(--color-gray-900);
    --border-card: var(--color-gray-700);

    /* Contact Info */
    --border-info: var(--color-gray-600);
  }
}
</style>
